import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ccfd638"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"color":"#f59a23 !important"} }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 新建结算单位 ")
const _hoisted_5 = {
  key: 0,
  style: {"color":"#317efd"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_v_nodes = _resolveComponent("v-nodes")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_select, {
      class: _normalizeClass([_ctx.class, "w100"]),
      value: _ctx.value,
      "allow-clear": "",
      "show-search": "",
      multiple: false,
      placeholder: _ctx.placeholder,
      "option-filter-prop": "title",
      onChange: _ctx.onChange,
      onClear: _ctx.onClear,
      onSearch: _ctx.onSearch
    }, _createSlots({
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data?.records, (item) => {
          return (_openBlock(), _createBlock(_component_a_select_option, {
            key: item.id,
            value: item.id,
            title: item.name
          }, {
            default: _withCtx(() => [
              (item.name.indexOf(_ctx.OverVal) > -1 && _ctx.OverVal != '')
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    _createTextVNode(_toDisplayString(item.name.substr(0, item.name.indexOf(_ctx.OverVal))), 1),
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.OverVal), 1),
                    _createTextVNode(_toDisplayString(item.name.substr(item.name.indexOf(_ctx.OverVal) + _ctx.OverVal.length)), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.name), 1))
            ]),
            _: 2
          }, 1032, ["value", "title"]))
        }), 128))
      ]),
      _: 2
    }, [
      (_ctx.addUnit)
        ? {
            name: "dropdownRender",
            fn: _withCtx(({ menuNode: menu }) => [
              _createVNode(_component_v_nodes, { vnodes: menu }, null, 8, ["vnodes"]),
              _createVNode(_component_a_divider, {
                style: {"margin":"4px 0"},
                id: "divider"
              }),
              _createElementVNode("div", {
                class: "add-text",
                style: {"padding":"4px 12px","cursor":"pointer"},
                onMousedown: _cache[0] || (_cache[0] = (e) => e.preventDefault()),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addItem && _ctx.addItem(...args)))
              }, [
                _createVNode(_component_plus_outlined),
                _hoisted_4,
                (_ctx.showOverVal)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "“" + _toDisplayString(_ctx.OverVal) + "”", 1))
                  : _createCommentVNode("", true)
              ], 32)
            ])
          }
        : undefined
    ]), 1032, ["class", "value", "placeholder", "onChange", "onClear", "onSearch"])
  ]))
}